import RegistrationForm from "./RegistrationForm";

interface BusinessRegistrationFormProps {
  onBack: () => void;
  onSubmit: (data: Record<string, unknown>) => void;
  isLoading?: boolean;
  error?: string;
  nameFromBankId?: boolean;
}

const BusinessRegistrationForm = ({
  onBack,
  onSubmit,
  isLoading = false,
  error,
  nameFromBankId = false,
}: BusinessRegistrationFormProps) => {
  return (
    <RegistrationForm
      onBack={onBack}
      onSubmit={onSubmit}
      isLoading={isLoading}
      error={error}
      userType="business"
      nameFromBankId={nameFromBankId}
    />
  );
};

export default BusinessRegistrationForm;
